export default {
	data () {
		return  {
			modals: {
                'modal-delete': {
                    box: ''
                }
            },
	    }
	},

	methods: {
        closeModal(modalName) {
            this.$bvModal.hide(modalName)
        },

        showAlertBox($type, $title, $msg) {
            let config = {
                width: '30%',
                icon: $type,
                title: $title,
                html: $msg,
            }
            
            // Don't auto-dismiss error/danger alerts - require manual dismissal
            if ($type !== 'error' && $type !== 'danger') {
                config.timer = 3500
            }
            
            this.$swal(config)
        },

		findIndex(dataset, col, value) {
            return dataset.findIndex(function(x) {
                return x[col] == value
            })
        },

        isMobile() {
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            if (width > 414) {
                return false
            } else {
                return true
            }
        },

        getImageUrl(sku, size, sequence, extension) {
            return '/storage/images/' + sku + '/' + sku + '_' + size + '_' + sequence + '.' + extension
        },

        scrollToElement(options, index) {
            this.$nextTick(() => {
                const el = this.$el.getElementsByClassName('index-' + index)[0];

                if (el) {
                    el.scrollIntoView(options);
                }
            })
        },

        camelToSnakeCase(text) {
            return text.replace(/(.)([A-Z][a-z]+)/, '$1_$2').replace(/([a-z0-9])([A-Z])/, '$1_$2').toLowerCase()
        },

        objFilter(data, keys_to_keep) {
            const redux = array => array.map(o => keys_to_keep.reduce((acc, curr) => {
                acc[curr] = o[curr];
                return acc
            }, {}))

            return redux(data)
        },

        calculateOpenOrders(lines) {
            let count = 0

            lines.forEach((row, idx, array) => {
                if (row.sale_order.status == 'Confirmed' || row.sale_order.status == 'Dispatched') {
                    count++
                }
            })

            return count
        },

        getDate() {
            return this.$moment().format('YYYY-MM-DD')
        },

        formatDateTimeToDate(date) {
            return this.$moment(date).format('YYYY-MM-DD')
        },

        getDateTime() {
            return this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },

        numberWithCommas(num) {
            if (!num) {
                return '0.00'
            } else {
                return Number(num).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
        },

        sumOfCol(obj, col) {
            return obj.reduce((accumulator, current) => accumulator + current[col], 0)
        },

        // Normalize b-table provider ctx so mount + sort-init calls produce the
        // same request params (BV often passes empty sortBy on the first call).
        normalizeTableProviderContext(ctx, tableState, defaults = {}) {
            let sortDesc = tableState.sortDesc

            if (ctx.sortDesc !== undefined && ctx.sortDesc !== null) {
                sortDesc = !!ctx.sortDesc
            } else if (defaults.sortDesc !== undefined) {
                sortDesc = !!defaults.sortDesc
            }

            return {
                currentPage: ctx.currentPage || tableState.currentPage || defaults.currentPage || 1,
                perPage: ctx.perPage || tableState.perPage || defaults.perPage || 20,
                sortBy: ctx.sortBy || tableState.sortBy || defaults.sortBy || null,
                sortDesc: sortDesc,
                filter: ctx.filter != null ? ctx.filter : (tableState.filter != null ? tableState.filter : '')
            }
        },

        // Debounces rapid b-table provider invocations into a single request.
        // Resolves every caller with the same result using the latest ctx.
        scheduleProviderFetch(namespace, ctx, fetchFn, delay = 50) {
            if (!this._providerWaiters) {
                this._providerWaiters = {}
            }
            if (!this._providerTimers) {
                this._providerTimers = {}
            }
            if (!this._providerLatestCtx) {
                this._providerLatestCtx = {}
            }

            this._providerLatestCtx[namespace] = ctx

            return new Promise((resolve, reject) => {
                if (!this._providerWaiters[namespace]) {
                    this._providerWaiters[namespace] = []
                }

                this._providerWaiters[namespace].push({ resolve, reject })

                if (this._providerTimers[namespace]) {
                    clearTimeout(this._providerTimers[namespace])
                }

                this._providerTimers[namespace] = setTimeout(() => {
                    const latestCtx = this._providerLatestCtx[namespace]
                    const waiters = this._providerWaiters[namespace] || []

                    delete this._providerTimers[namespace]
                    delete this._providerWaiters[namespace]
                    delete this._providerLatestCtx[namespace]

                    Promise.resolve(fetchFn(latestCtx))
                        .then((result) => {
                            waiters.forEach((w) => w.resolve(result))
                        })
                        .catch((err) => {
                            waiters.forEach((w) => w.reject(err))
                        })
                }, delay)
            })
        }
  	}
}
